import { render, staticRenderFns } from "./ClassicBlocField.vue?vue&type=template&id=64220968&lang=pug&"
import script from "./ClassicBlocField.vue?vue&type=script&lang=js&"
export * from "./ClassicBlocField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64220968')) {
      api.createRecord('64220968', component.options)
    } else {
      api.reload('64220968', component.options)
    }
    module.hot.accept("./ClassicBlocField.vue?vue&type=template&id=64220968&lang=pug&", function () {
      api.rerender('64220968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/schematic/blocs/ClassicBlocField.vue"
export default component.exports